import 'css-chunksrc/client/common/layout/projectHistory/styles.scss';export default {
  "projectHistory": "_projectHistory_6liv2_1",
  "input": "_input_6liv2_5",
  "projectIcon": "_projectIcon_6liv2_21",
  "toggleIcon": "_toggleIcon_6liv2_26",
  "listRoot": "_listRoot_6liv2_33",
  "main": "_main_6liv2_41",
  "search": "_search_6liv2_51",
  "item": "_item_6liv2_59",
  "icon": "_icon_6liv2_72",
  "open": "_open_6liv2_79"
};